import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ModeratorService } from 'src/app/shared/moderator/moderator.service';
import { ExpertService } from 'src/app/shared/techExpert/expert.service';
import { LoginService } from 'src/app/shared/user-login/login.service';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-view-all-transactions',
    templateUrl: './view-all-transactions.component.html',
    styleUrls: ['./view-all-transactions.component.css'],
    standalone: false
})
export class ViewAllTransactionsComponent implements OnInit {

  role;
  serverErrorMessages;
  alltransactions;
  startDate;
  endDate=this.transformDate(new Date());
  allCustomers
  allFilteredCustomers
  transaction
  transactions;
  totalTransactions=[];
  loading: Boolean = true
  dateForm = new FormGroup({
    startDate: new FormControl(),
    endDate: new FormControl()
  })
  missingFields = false;

  constructor(private loginService: LoginService, private router : Router, private moderatorService: ModeratorService, private expertService: ExpertService, private datePipe: DatePipe) { }

  ngOnInit(): void {
    if(this.loginService.isLoggedIn()){
      this.loginService.getUserProfile().subscribe(
        res => {
          this.role = res['user'].role.toString();
         //console.log('User', this.role);
          this.getAllTransactions();
          this.loading = false;
         //console.log(this.endDate);
        },
        err => {
         //console.log('Didnt get logged in user', err);
          this.serverErrorMessages = err.error.message;
          this.loading = false;
        }
      )
    }
  }

  unauthorised(){
    setTimeout(() => {
      this.loginService.deleteToken();
     //console.log('BYE BYE');
      this.router.navigateByUrl('/signin');
    }, 3000);
  }

  getAllTransactions(){
    if (this.role == 'MODERATOR') {
    this.moderatorService.getAllTransactions().subscribe(
      res=>{
        // console.log(res)
        this.allCustomers = res[0]
        console.log(this.allCustomers)
      //   this.allCustomers.shift();
      //   this.allCustomers.shift();
        this.allFilteredCustomers = this.allCustomers;
      //   // this.transaction = res['transactions'][4]
      //   // this.alltransactions = this.transaction['transactions']
      //   // this.transactions=this.alltransactions

      //   console.log(this.allCustomers);

      //   for(let customer of this.allCustomers)
      //   {
      //     for(let trans of customer.transactions)
      //     {
      //       this.totalTransactions.push(trans);
      //     }
      //   }

      //   console.log(this.totalTransactions)

      //  //console.log('got all transactions', this.alltransactions);
      },
      err=>{
       //console.log('error getting transacions', err)
      }
    )
    }
    else if (this.role == 'TECHEXPERT') {
      // this.expertService.getAllTransactions().subscribe(
      //   res=>{
      //     this.transaction = res['transactions'][0]
      //     this.alltransactions = this.transaction['transactions']
      //     this.transactions=this.alltransactions
      //    //console.log('got all transactions', this.alltransactions);
      //   },
      //   err=>{
      //    //console.log('error getting transacions', err)
      //   }
      // )

      this.expertService.getAllPaidTransaction().subscribe(
        res => {
         //console.log('got paid transactions', res)
        },
        err => {
         //console.log('error', err)
        }
      )

      this.expertService.getAllUnpaidTransaction().subscribe(
        res => {
         //console.log('got unpaid transactions', res)
        },
        err => {
         //console.log('error', err)
        }
      )
      }
  }

  filter(){
    this.startDate=this.transformDate(this.dateForm.get('startDate').value)
    this.endDate=this.transformDate(this.dateForm.get('endDate').value)
    if ( !this.startDate || !this.endDate ) this.missingFields=true
    else {
      this.dateForm.reset()
      this.missingFields=false
      console.log(this.startDate, this.endDate)
      this.transactions = []
      this.allFilteredCustomers = [];
      // let newObj={
      //   customerId : {},
      //   transactions : []
      // };
      for(let customer of this.allCustomers)
        {
          let newObj={
            customerId : {},
            transactions : []
          };
          for(let x of customer.transactions)
          {
            var d = this.transformDate(x.createdAt)
            if (d>=this.startDate && d<=this.endDate) {
              // newObj.customerId = customer.customerId;
              newObj.transactions.push(x);
              
            }
          }
          if(newObj.transactions.length!=0)
          {
            newObj.customerId = customer.customerId;
            console.log(newObj)
            this.allFilteredCustomers.push(newObj)
          }
        }

      // for (var x of this.totalTransactions) {
      //   var d = this.transformDate(x.createdAt)
      //   if (d>=this.startDate && d<=this.endDate) {
      //     this.transactions.push(x)
      //   }
      // }
      console.log("New transactions", this.allFilteredCustomers)
    }
  }

  reset() {
    this.dateForm.reset()
    this.missingFields=false
    this.transactions = this.totalTransactions;
    this.allFilteredCustomers = this.allCustomers;
  }

  transformDate(x){
    return(this.datePipe.transform(x, 'yyyy-MM-dd'));
  }

  //To be done
  // downloadPdf() {

  // }

}
